import React from 'react'

const AppleMusicVolume = ({theme = 'dark'}) => {
    return (
        <apple-music-progress theme={theme}></apple-music-progress>
    )
}

export default AppleMusicVolume